import type { Notification } from './notification.service';

export function getNotificationsToAppend(
  existingNotifications: Notification[],
  incomingNotifications: Notification[],
): Notification[] {
  const existingMessageIds = new Set(
    existingNotifications
      .map((notification) => notification.message_id)
      .filter(Boolean),
  );

  return incomingNotifications.filter((notification) => {
    if (!notification.message_id) {
      return true;
    }
    if (existingMessageIds.has(notification.message_id)) {
      return false;
    }
    existingMessageIds.add(notification.message_id);
    return true;
  });
}
